import { useState, useEffect } from 'react';
import dashboardService from '../services/dashboardService';
function useVariablesBotAvailable(dashboard_channel_id, bot_id, exceptions, defaultValue = null) {
    const [variablesBot, setVariablesBot] = useState("")
    const { getBotVariableAvailable } = dashboardService;
    async function setUpVariableBotRender() {
        const [response, errors] = await getBotVariableAvailable({ dashboard_channel_id: dashboard_channel_id, bot_id: bot_id, exception: exceptions });
        if (errors != null) {
            console.log(errors)
            return;
        }
        let variables = response;
        variables = variables.sort((a, b) => a.name[0].localeCompare(b.name[0]))
        let result = [];
        variables.forEach(_variable => {
            result.push({
                value: _variable.id,
                text: _variable.name
            })
        });
        if (defaultValue != null) {
            result.push({
                value: defaultValue.value,
                text: defaultValue.text
            })
        }
        setVariablesBot(result)
    }

    useEffect(() => {
        setUpVariableBotRender();
    }, []);

    return { variablesBot, setVariablesBot };
}

export default useVariablesBotAvailable;